import { palette } from '../../foundations/__generated__/palette.js';
const themeSpinner = {
    background: palette.brand[800],
    color: palette.brand[400]
};
export { themeSpinner };
